export default IconSteam => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-steam" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M4 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M20 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M5.5 5.5l3 3" />
  <path d="M15.5 15.5l3 3" />
  <path d="M18.5 5.5l-3 3" />
  <path d="M8.5 15.5l-3 3" />
</svg>`;